import { gsap } from '../global/gsap';

const initOverlays = (overlayToggles) => {
    const html = document.documentElement;
    const togglesArray = [...overlayToggles];
    const menuToggle = document.querySelector('[data-toggle="menu"]');

    const menuClass = 'menu-open';
    const searchCLass = 'search-open';

    window.menuActive = false;
    window.searchActive = false;

    if (document.body.dataset.page === 'search') {
        window.searchActive = true;
    }

    const isDesktop = window.matchMedia('(width >= 56.25em)');

    const searchOverlay = document.querySelector('.js-search-overlay');
    const searchInput = searchOverlay.querySelector('.js-search-input');
    const searchUnfocused = searchOverlay.querySelectorAll('[tabindex="-1"]');

    const menuOverlay = document.querySelector('.js-menu-overlay');
    const menuGrid = menuOverlay.querySelector('.js-menu-grid');
    const menuSectors = menuOverlay.querySelector('.js-menu-sectors');
    const menuList = menuOverlay.querySelector('.js-menu-list');

    const mainMenu = menuOverlay.querySelector('.js-menu-main');
    let menuItems = null;

    if (mainMenu) {
        menuItems = mainMenu.querySelectorAll('li a');
    }

    const menuUnfocused = menuOverlay.querySelectorAll('[tabindex="-1"]');

    let menuTl;

    const updateAnimation = (target) => {
        if (menuItems) {
            gsap.set(menuItems, {
                opacity: 0,
                y: '150%'
            });
        }

        menuTl = gsap.timeline({
            paused: true,
            overwrite: true,
            defaults: {
                duration: 0.55,
                ease: 'power1'
            },
            onComplete: () => {
                html.classList.add('menu-animation-finished');
            }
        });

        if (target.matches) {
            gsap.set(menuList, {
                opacity: 1,
                x: '150%'
            });

            gsap.set(menuSectors, {
                x: '125%',
                opacity: 0
            });

            menuTl.to(menuList, {
                x: 0
            }).to(menuSectors, {
                x: '70%',
                opacity: 1,
                delay: -0.15
            }).to(menuItems, {
                delay: -0.65,
                opacity: 1,
                y: '0',
                stagger: 0.05
            });
        } else {
            gsap.set(menuList, {
                x: 0,
                opacity: 1
            });

            gsap.set(menuSectors, {
                opacity: 0,
                x: 0
            });

            menuTl.to(menuItems, {
                delay: -0.55,
                opacity: 1,
                y: '0',
                stagger: 0.05
            }).to(menuSectors, {
                opacity: 1
            });
        }

        // Reset menu position
        window.menuActive = false;
        html.classList.remove(menuClass);
        html.classList.remove('menu-animation-finished');
        menuToggle.textContent = 'Menu';
        menuTl.pause(0);

        if (menuUnfocused && menuUnfocused.length > 0) {
            menuUnfocused.forEach((item) => {
                item.tabIndex = -1;
            });
        }
    };

    updateAnimation(isDesktop);

    isDesktop.addEventListener('change', (event) => {
        updateAnimation(event);
    });

    document.addEventListener('click', (event) => {
        if (togglesArray.includes(event.target)) {
            event.preventDefault();

            const toggle = event.target;

            // Check for toggle types
            if (toggle.dataset.toggle === 'menu') {
                window.menuActive = !window.menuActive;

                if (window.menuActive) {
                    html.classList.add(menuClass);

                    toggle.textContent = 'Close';

                    menuTl.play();

                    if (menuUnfocused && menuUnfocused.length > 0) {
                        menuUnfocused.forEach((item) => {
                            item.tabIndex = 0;
                        });
                    }

                    // If search is open, close it
                    if (window.searchActive) {
                        window.searchActive = false;
                        html.classList.remove(searchCLass);

                        searchInput.blur();
                        searchInput.value = '';
                        searchInput.tabIndex = -1;

                        if (searchUnfocused && searchUnfocused.length > 0) {
                            searchUnfocused.forEach((item) => {
                                item.tabIndex = -1;
                            });
                        }
                    }
                } else {
                    html.classList.remove(menuClass);
                    html.classList.remove('menu-animation-finished');
                    toggle.textContent = 'Menu';
                    menuTl.pause(0);

                    if (menuUnfocused && menuUnfocused.length > 0) {
                        menuUnfocused.forEach((item) => {
                            item.tabIndex = -1;
                        });
                    }
                }
            }

            if (toggle.dataset.toggle === 'search') {
                window.searchActive = !window.searchActive;

                if (window.searchActive) {
                    html.classList.add(searchCLass);

                    searchInput.focus();
                    searchInput.tabIndex = 0;

                    if (searchUnfocused && searchUnfocused.length > 0) {
                        searchUnfocused.forEach((item) => {
                            item.tabIndex = 0;
                        });
                    }

                    // If menu is open, close it
                    if (window.menuActive) {
                        window.menuActive = false;
                        html.classList.remove(menuClass);
                        html.classList.remove('menu-animation-finished');
                        menuToggle.textContent = 'Menu';
                        menuTl.pause(0);

                        if (menuUnfocused && menuUnfocused.length > 0) {
                            menuUnfocused.forEach((item) => {
                                item.tabIndex = -1;
                            });
                        }
                    }
                } else {
                    html.classList.remove(searchCLass);

                    searchInput.blur();
                    searchInput.value = '';
                    searchInput.tabIndex = -1;

                    if (searchUnfocused && searchUnfocused.length > 0) {
                        searchUnfocused.forEach((item) => {
                            item.tabIndex = -1;
                        });
                    }
                }
            }
        } else if ((event.target !== menuGrid && !event.target.closest('.js-menu-grid')) && window.menuActive) {
            window.menuActive = false;
            html.classList.remove(menuClass);
            html.classList.remove('menu-animation-finished');

            menuToggle.textContent = 'Menu';
            menuTl.pause(0);

            if (menuUnfocused && menuUnfocused.length > 0) {
                menuUnfocused.forEach((item) => {
                    item.tabIndex = -1;
                });
            }
        } else if ((event.target !== searchOverlay && !event.target.closest('.js-search-overlay')) && window.searchActive && document.body.dataset.page !== 'search') {
            window.searchActive = false;
            html.classList.remove(searchCLass);

            searchInput.blur();
            searchInput.value = '';
            searchInput.tabIndex = -1;

            if (searchUnfocused && searchUnfocused.length > 0) {
                searchUnfocused.forEach((item) => {
                    item.tabIndex = -1;
                });
            }
        }
    });
};

export { initOverlays as default };
